import { getLogicGroupConditionsSize } from '../../filterQueryFormat/logic/LogicGroup';
import { useContext, useMemo } from 'react';
import { useViewerActions } from '../../hooks/useViewerActions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerEditButton = () => {
  const {
    internalDraftValue,
    internalDraftValueBeforeEdit,
    isInEditMode,
    props: {
      showDoneButton,
      hideEditCancelDiscardButton,
      isReadOnly,
      editButtonsState,
      originalValue,
      value,
      layout,
      uiMessages: {
        editFiltersButtonLabel
      }
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    disabled: isEditButtonDisabled,
    tooltipHeadingText,
    tooltipTitle
  } = editButtonsState || {};
  const {
    onEditFilters,
    onDiscardChanges,
    onConfirmChanges,
    onCancelChanges
  } = useViewerActions();

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'LogicGroupInstance | undefined' ... Remove this comment to see the full error message
  const hasNoConditions = getLogicGroupConditionsSize(internalDraftValue) === 0;
  const showDiscardChangesButton = useMemo(() => originalValue && JSON.stringify(originalValue) !== JSON.stringify(value) || internalDraftValueBeforeEdit && !internalDraftValueBeforeEdit.equals(internalDraftValue), [internalDraftValue, internalDraftValueBeforeEdit, originalValue, value]);
  if (isReadOnly || hideEditCancelDiscardButton) {
    return null;
  }
  if (!isInEditMode) {
    return /*#__PURE__*/_jsx(UITooltip, {
      disabled: !isEditButtonDisabled,
      headingText: tooltipHeadingText,
      placement: "bottom",
      title: tooltipTitle,
      use: "longform",
      children: /*#__PURE__*/_jsx(UIButton, {
        "data-selenium-test": "fr-edit-filters",
        size: "xs",
        use: "tertiary",
        onClick: onEditFilters,
        disabled: hasNoConditions || isEditButtonDisabled,
        responsive: false,
        children: editFiltersButtonLabel || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.filtersViewer.editFilters"
        })
      })
    });
  }
  if (showDiscardChangesButton) {
    const shouldShowDoneButton = layout === 'embedded' && showDoneButton;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        "data-selenium-test": "fr-discard-changes",
        size: "xs",
        use: "tertiary-light",
        onClick: onDiscardChanges,
        responsive: false,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.filtersViewer.discardChanges"
        })
      }), shouldShowDoneButton && /*#__PURE__*/_jsx(UIButton, {
        "data-selenium-test": "fr-confirm-changes",
        size: "xs",
        use: "tertiary",
        onClick: onConfirmChanges,
        responsive: false,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.filtersViewer.confirmChanges"
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(UIButton, {
    "data-selenium-test": "fr-cancel-edit-filters",
    size: "xs",
    use: "tertiary-light",
    onClick: onCancelChanges,
    responsive: false,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCustomerDataFilters.filtersViewer.cancelEditing"
    })
  });
};
export default ViewerEditButton;